export default __webpack_public_path__ + "static/media/pontos-de-comentario.fba5aa0d.png";